import ErrorBoundary from '@innovyze/stylovyze/lib/components/ErrorBoundary';
import WidgetError from '@innovyze/stylovyze/lib/components/WidgetError';
import React from 'react';
/**
 * Error boundary for widget
 */
class WidgetErrorBoundary extends ErrorBoundary {
    render() {
        const { errorMessage, children } = this.props;
        const { hasError, error } = this.state;
        if (hasError) {
            return React.createElement(WidgetError, { message: errorMessage || error.message });
        }
        return children;
    }
}
WidgetErrorBoundary.defaultProps = {
    errorFallbackMessage: 'There was an error loading this information',
};
export default WidgetErrorBoundary;
